import { isMobile } from '@/utils';
import { STORE_APP_BANNER_ENTRY } from './index';

interface IOldUserCenterUrl {
  uid: number;
  uuid: string;
}
export const pageBaseUrl = '/pro';

export const host = process.env.HOST;

export const oldThreadPhotoPrefix = process.env.OLD_THREAD_PHOTO_PREFIX;

// 导航栏右上角头像以及下拉的个人中心
export const oldUserCenterUrl = ({ uid, uuid }: IOldUserCenterUrl) => {
  const mod = isMobile ? 'mode' : 'mod';
  return `/pro/user-center?uid=${uid}&uuid=${uuid}`;
};

export const getDetailUrl = (tid: number, isStoreAppEntry = false) =>
  `${process.env.SITE_ORIGIN}${pageBaseUrl}/detail?tid=${tid}${
    isStoreAppEntry ? `&entry=${STORE_APP_BANNER_ENTRY}` : ''
  }`;

export const searchUrl = `${process.env.SITE_ORIGIN}/search.php?mod=forum&mobile=2`;

export const videoCenterHosts = ['vip.aasky.net', 'djivideos.com'];

export const getUserHomeUrl = (uid?: number, uuid?: string) => {
  if (!uid || uuid == null) {
    return '';
  }
  const mod = isMobile ? 'mode' : 'mod';
  return `${process.env.SITE_ORIGIN}/pro/user-center?uid=${uid}&uuid=${uuid}`;
};

export const getTopLevelNavPageUrl = (fid: string) =>
  `${process.env.SITE_ORIGIN}/forum-${fid}-1.html`;

export const getSecondLevelNavPageUrl = (fid: string, typeid: number) =>
  `${process.env.SITE_ORIGIN}/pro/detail?mod=forumdisplay&fid=${fid}&filter=typeid&typeid=${typeid}`;

/**
 * 获取搜索页url
 * @param searchVal 搜索关键词
 * @returns 搜索页url
 */
export const getSearchPageUrl = (searchVal: string = '') => {
  // 开发环境使用当前页面地址作为基础地址
  const baseUrl = process.env.ENV === 'dev' ? (typeof window !== 'undefined' ? window.location.origin : '') : process.env.SITE_ORIGIN;
  if(searchVal) {
    return `${baseUrl}/pro/search?keyword=${searchVal}`
  } else {
    return `${baseUrl}/pro/search`
  }
};

/**
 * 获取搜索页url
 * @param searchVal 搜索关键词
 * @returns 搜索页url
 */
export const getSearchUrl = (searchVal: string = '') => {
  if(searchVal) {
    return `/pro/search?keyword=${encodeURIComponent(searchVal)}`
  } else {
    return '';
  }
};

export const pagePathUrlOnlyM = {
  /** 首页推荐 */
  home: `${pageBaseUrl}/home`,
  /** 首页广场 */
  square: `${pageBaseUrl}/square`,
  /** 首页咨询 */
  consult: `${pageBaseUrl}/consult`,
  /** 首页活动 */
  activity: `${pageBaseUrl}/activity`,
  /** 设备圈 */
  devicesSeries: `${pageBaseUrl}/devices`,
  /** 设备主题（动态路由） */
  device: `${pageBaseUrl}/device-item`,
  /** 我的积分 */
  points: `${pageBaseUrl}/points`,
  profile: `${pageBaseUrl}/profile`,
  /** 圈子列表 */
  circleList: `${pageBaseUrl}/group`,
  /** 个人中心 */
  userCenter: `${pageBaseUrl}/user-center`,
  /** 消息中心 */
  message: `${pageBaseUrl}/message`,
};

/** 新页面路由 */
export const pagePathUrl = {
  /** 详情页 */
  detail: `${pageBaseUrl}/detail`,
  /** 发帖页 */
  edit: `${pageBaseUrl}/edit`,
  /** 我的帖子 */
  myPosts: `${pageBaseUrl}/myPosts`,
  /** 收藏 */
  favorite: `${pageBaseUrl}/favorite`,
  /** 健康检查 */
  health: `${pageBaseUrl}/health-check`,
  /** 搜索页 */
  serch: `${pageBaseUrl}/search`,
  /** 403页面 */
  accessDenied: `${pageBaseUrl}/access-denied`,
  ...pagePathUrlOnlyM,
};

export const homeRouterPageName = {
  /** 首页推荐 */
  home: '/home/mIndex',
  /** 首页广场 */
  square: '/square/mIndex',
  /** 首页咨询 */
  consult: '/consult/mIndex',
  /** 首页活动 */
  activity: '/activity/mIndex',
  /** 设备圈 */
  devicesSeries: '/devices/mIndex',
  /** 设备主题（动态路由） */
  device: '/device-item/[slug]/mIndex',
  /** 用户名昵称修改 */
  profile: '/profile/mIndex',
};

/** 需要展示回到顶部按钮的页面配置 */
export const displayBackToTopRouters = ['home', 'square', 'detail', 'consult', 'activity', 'devices', 'device', 'group', 'search'];


export const notShowFeedBack = {
  /** m编辑页 */
  mEdit: '/edit/mIndex',
  /** pc编辑页 */
  edit: '/edit',
};

/* 点赞收藏lottie动画url */
export const USER_ACTION_LOTTIE_URL = {
  /** 点赞动画url */
  PRAISE: 'https://static.djicdn.com/dji-bbs/v1/_next/static/scripts/thumbup.lottie',
  /** 收藏动画url */
  COLLECT: 'https://static.djicdn.com/dji-bbs/v1/_next/static/scripts/favorite.lottie',
}

// 支持webp的图片域名
export const supportWebpDomain = [
  'hz-bbs-stag.oss-cn-hangzhou.aliyuncs.com',
  'bbs.djicdn.com',
  'bbs-test.djicdn.com',
  'stag-cn-videos.dji.net',
  'skp-cn-cdn.djiits.com',
  'skp-cn-cdn.djiits.com',
  'cn-videos.dji.net',
];